export interface BodyCreateUser {
  companyUserId: number;
  idBranch: number;
  nombre: string;
  apellido: string;
  roles: string[];
  userState: boolean;
  username: string;
  password: string;
  email: string;
}

export interface ResponseCreateUser {
  message:       string;
  id:            number;
  username:      string;
  email:         string;
  roles:         string[];
  companyUserId: number;
  idBranch:      number;
}


export interface BodyUpdateUser {
  id_user: number;
  id_company: number;
  id_branch: number;
  nombre: string;
  apellido: string;
  username: string;
  password: string;
  email: string;
  id_rol: string[];
  userState: boolean;
  menu: "por_defecto" // TODO:  - Nota: por defecto mientras se implementa la funcionalidad de menú personalizado
}

export interface ResponseUpdateUser {
  message:       string;
  id_user:            number;
  username:      string;
  email:         string;
  id_rol:         string[];
  id_company: number;
  id_branch:      number;
  userState: boolean;
  menu: "por_defecto" // TODO: - Nota: por defecto mientras se implementa la funcionalidad de menú personalizado
}

export interface ResponseListUsers {
  Id:          number;
  Id_Empresa:  number | null;
  Id_Sucursal: number | null;
  Nombre:      string;
  Apellido:    string;
  Usuario:     string;
  Contraseña:  string;
  Correo:      string;
  Empresa:     string;
  Sucursal:    string;
  Estado:      boolean | string;
  Rol:         string;
  Menu:       string;  // TODO: - Nota: por defecto mientras se implementa la funcionalidad de menú personalizado
}
